import { getBackVersion } from '../../../config';
import api from '../../api';
import {
    RentAdvancePersonalDataCreationSnapshot,
    RentAdvancePersonalDataSnapshot,
} from '../../../models/LandlordArea/RentAdvance';
import { decamelizeKeys } from '../../../lib';

const getPersonalData = (
    rentAdvanceId: number
): Promise<RentAdvancePersonalDataSnapshot> =>
    api.request<RentAdvancePersonalDataSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/personal_data`,
    });

const setPersonalData = (
    rentAdvanceId: number,
    personalData: RentAdvancePersonalDataCreationSnapshot
): Promise<RentAdvancePersonalDataSnapshot> =>
    api.request<RentAdvancePersonalDataSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/landlord_area/rent_advances/${rentAdvanceId}/personal_data`,
        data: decamelizeKeys(personalData),
    });

export { setPersonalData, getPersonalData };
